import yup from "../../../../validation/yup";

import { USER_FIRSTNAME, USER_LASTNAME } from "../../../../validation/user";

export const validationSchema = yup.object().shape({
  firstName: USER_FIRSTNAME.required(),
  lastName: USER_LASTNAME.required(),
});
